<template>
    <div class="homePage">
        <el-carousel >
            <el-carousel-item v-for="(url,index) in pictureList" :key="index" >
                <el-image
                        class="carousel-img"
                        :src="url"
                        fit="cover"></el-image>
            </el-carousel-item>
        </el-carousel>




        <div class="chanpin-tedian">
            <el-row class="chanpin-tedian-title">
                <el-col :lg="{span:4,offset:10}" :md="{span:24,offset: 0}" >数字病理切片扫描仪TB-1</el-col>
            </el-row>
            <el-row class="chanpin-tedian-detail">
                <el-col  :lg="{span:4,offset:5}"  :md="{span:24,offset:0}">
                    <img src="@/../static/iamges/chanpin.png">
                </el-col>
                <el-col class="detail-text" :lg="{span:12,offset:3}" :md="{span:24,offset:0}" >
                    <el-row style="margin-top: 15px">体积小、重量轻，方便携带</el-row>
                    <el-row style="margin-top: 15px">速度快，最快30S完成15mm*15mm区域扫描</el-row>
                    <el-row style="margin-top: 15px">自带AI建模系统，可细胞分类标注、数阳性细胞<br>识别特殊组织、远程标注模型解释、生成严谨美观的论文配图</el-row>
                    <el-row style="margin-top: 15px">智能远程拼接专利技术，可用于远程诊断服务</el-row>
<!--                    <el-row style="margin-top: 20px"><el-button type="primary" @click="gotoDetail">产品详情</el-button></el-row>-->
                </el-col>
            </el-row>
        </div>





        <div class="contactUs">
            <el-row class="contactUs-title" style="margin-bottom: 50px">联系我们</el-row>
            <el-row class="contactUs-logo">
                <el-col :lg="{span:10,offset:2}" :md="{span:24,offset:0}">
                    <img src="@/../static/iamges/logo.png">
                </el-col>
                <el-col :lg="{span:12}" :md="{span:24}" :sm="{span:24}">
                    <el-row class="contactUs-detail" v-for="(item,index) in contactUs" :key="index">
                        <el-col  :lg="{span:2,offset:0}" :md="{span:2,offset:0}" :sm="{span:2,offset:6}" >
                            <img :src="item.icon">
                        </el-col >
                        <el-col :lg="{span:5}"   :md="{span:14}"  :sm="{span:14}" style="color: black;font-weight: 600;white-space: nowrap" >{{item.text}}</el-col>
                    </el-row>
                </el-col>
            </el-row>
        </div>




    </div>
</template>
<script>
    export default {
        name: "Homepage",
        mounted() {
            this.$emit("handleSelect","0",["0"])
        },
        data() {
            return {
                pictureList: [
                    // require("@/../static/iamges/1.png"),
                    require("@/../static/iamges/sample.png"),
                    require("@/../static/iamges/gs.jpg"),

                ],
                contactUs:[
                    {
                        icon: require("@/../static/iamges/phone.png"),
                        text: "18121496883"
                    },
                    {
                        icon: require("@/../static/iamges/location.png"),
                        text: "江苏省苏州市工业园区仁爱路99号D2-410.411"
                    },
                    {
                        icon: require("@/../static/iamges/email.png"),
                        text: "product@medppp.com"
                    },
                    {
                        icon: require("@/../static/iamges/www.png"),
                        text: "www.turingene.com"
                    },
                ],
                activeIndex: '1',
                menuItemStyle: [
                    {backgroundColor: "#074A81", color: "#fff"},
                    {backgroundColor: "#E4E4E4", color: "#000"},
                    {backgroundColor: "#E4E4E4", color: "#000"},
                    {backgroundColor: "#E4E4E4", color: "#000"},
                    {backgroundColor: "#E4E4E4", color: "#000"}
                ],
                selectedKey: 0,

            }
        },
        methods: {
            handleSelect(key, keyPath) {
                console.log(key, keyPath);
                this.selectedKey = key;
                console.log(this.selectedKey);
                this.menuItemStyle = [
                    {backgroundColor: "#E4E4E4", color: "#000"},
                    {backgroundColor: "#E4E4E4", color: "#000"},
                    {backgroundColor: "#E4E4E4", color: "#000"},
                    {backgroundColor: "#E4E4E4", color: "#000"},
                    {backgroundColor: "#E4E4E4", color: "#000"}
                ]
                this.menuItemStyle[key] = {backgroundColor: "#074A81", color: "#fff"}
            },
            gotoDetail(){
                this.$root.$index.handleSelect("3",["1","3"]);
                this.$router.push({
                    path:"/productDetails"
                })
            }
        }
    }
</script>

<style scoped lang="css">
    @media only screen and (max-width: 992px) {
        .homePage{
            padding-top: 50px;
        }
        .el-carousel >>> .el-carousel__container{
            height: 200px;
        }
        .carousel-img >>> img{
            width: 100vw;
            height: 200px!important;
        }
        .detail-text{
            text-align: center;
        }
        .chanpin-tedian-detail {
           text-align: center;
        }
        .lichengPc{
            width:100vw;
            margin-top: 80px;
        }
        .aboutUs-detail{
            padding: 0px 50px;
        }
        .contactUs-logo{
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            /* align-content: center; */
            align-items: flex-start;
        }
        .contactUs-logo img{
            width: 100vw;
        }
        .contactUs-detail{
            display: flex;
            justify-content: flex-start;
            align-items: center;
            /*text-align: left;*/
            padding-right: 2px;
            padding-left: 2px;

        }
         .contactUs-detail >>> .el-col-24 {
            width: 10%;
        }
    }
    @media only screen and (min-width: 768px){
        .el-carousel >>> .el-carousel__container{
            height: 400px;
        }
        .carousel-img >>> img{
            width: 100vw;
            height: 400px!important;
        }
        .contactUs-logo img {
            width: 65vw;

        }
        .contactUs-detail{
            display: flex;
            align-items: center;
            /*margin-left: 150px;*/


        }
    }

    @media only screen and (min-width: 992px) {

        .el-carousel >>> .el-carousel__container{
            height: 500px;
        }
        .carousel-img >>> img{
            width: 100vw;
            height: 500px!important;
        }
        .detail-text{
           text-align: left;
            font-size: 20px ;
            color: gray;
            margin-top: -38px
        }
        .chanpin-tedian-detail {
            margin-top: 30px;
            display: flex;
            align-items: center;
        }
        .lichengPc{
           width: 1400px;
            margin-top: 80px
        }
        .aboutUs-detail {
            font-size: 18px;
            margin-top: 50px;
            color: gray;
            padding: 0px 242px;
            margin-bottom: 100px;

        }
        .contactUs-logo img {
            width: 350px;
            height: 230px;
        }
        .contactUs-logo{
            display: flex;
            justify-content: space-around;
            align-items: center;
        }
        .contactUs-detail{
            display: flex;
            align-items: center;
            text-align: left;
        }

    }


    .homePage-chanpin .chanpin-picture img {
        width: 300px;
        height: 300px;
    }

    .chanpin-picture-title, .chanpin-tedian-title, .hzhuoban-title, .contactUs-title {
        font-size: 25px;
        font-weight: 600;
        margin-bottom: 20px;
        color: #074A81;
    }

    .chanpin-tedian {
        margin-top: 60px;
        padding: 50px 0px;
        background-color: rgba(226, 226, 226, 0.3);
    }




    .chanpin-tedian-detail img {
        width: 290px;
        height: 380px;
    }

    .hzhuoban {
        margin-top: 10px;
        padding: 80px 0;
    }

    .hzhuoban img {
        width: 50vw;
        margin-top: 30px;
    }

    .el-carousel__item h3 {
        color: #475669;
        font-size: 14px;
        opacity: 0.75;
        line-height: 150px;
        margin: 0;
    }



    .contactUs {
        margin-top: 50px;
        padding-top: 50px;
        padding-bottom: 60px;
        background-color: rgba(172, 172, 172, 0.45);

    }

    .contactUs-detail img {
        margin-top: 5px;
        width: 30px;
        height: 30px;

    }

    .aboutUs {
        height: 100%;
        width: 100%;
        margin-top: 80px;
    }

    .aboutUs-head {
        width: 100%;
        height: 90px;
        /*background-color: rgba(217, 217, 217, 0.37);*/

    }

    .aboutUs-head-text {
        font-size: 25px;
        font-weight: 600;
        color: #074A81;
        /*text-align: left;*/
        line-height: 90px;
        /*margin-left: 100px;*/
        text-align: center;
    }

    .gongsilicheng {
        margin-top: 50px;
        /*height: 68vh;*/
        background-color: rgba(43, 112, 178, 0.03);
        padding-top: 60px ;
        padding-bottom: 120px;
        /*background-color: #36B9ED;*/
        /*background-color: #4587ed;*/
        width: 100%;
        display: flex;
        /*align-items: center;*/
        justify-content: center;
        /*overflow: hidden;*/

        flex-direction: column;
    }
    .gongsilicheng .items {
        display: flex;
        justify-content: space-evenly;
        align-items: flex-end;
    }

    .gongsilicheng .item {
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
    }

    .gongsilicheng .text {
        /*width: 10vw;*/
        color: #fff;
        font-size: 14px;
    }

    .gongsilicheng .dot {
        width: 10px;
        height: 10px;
        background-color: white;
        border-radius: 10px;
    }

    .gongsilicheng .line {
        border: solid 1px white;
        height: 800px;
    }

    .About-rongyu el-menu-item {
        font-size: 30px;
    }

    .rongyu-detail {
        font-size: 23px;
        font-weight: 500;
        width: 230px;
        border: 1px solid rgba(244, 244, 244, 0.5)
    }

    .About-rongyu-left, .About-rongyu-right {
        text-align: left;
        margin-top: 30px;
    }

    .left-text {
        margin-top: 30px;
    }

    .About-rongyu-right {
        display: flex;
        justify-content: flex-start;
        margin-left: -25px;
    }

    .About-rongyu-right img {
        box-shadow: 5px 5px 10px -5px black;
    }

    .btn-group {
        display: flex;
        justify-content: space-around;
    }

    .btns {
        width: 100%;
        height: 60px;
        line-height: 60px;
        font-size: 23px;
        border: 1px solid rgba(247, 247, 247, 1);
    }
    p{
        white-space: normal;
        text-align: left;
        text-indent: 2em;
        margin: 10px auto;
        line-height: 35px;

    }
</style>